import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.0476 5.67346L9.39683 4.91421L10.0476 5.67346ZM13.9524 5.67346L13.3016 6.43272V6.43272L13.9524 5.67346ZM19 11.3798H18V16H19H20V11.3798H19ZM5 16H6V11.3798H5H4V16H5ZM6.04763 9.10204L6.69842 9.86129L10.6984 6.43272L10.0476 5.67346L9.39683 4.91421L5.39683 8.34278L6.04763 9.10204ZM13.9524 5.67346L13.3016 6.43272L17.3016 9.86129L17.9524 9.10204L18.6032 8.34278L14.6032 4.91421L13.9524 5.67346ZM16 19V18H8V19V20H16V19ZM19 11.3798H20C20 10.2121 19.4897 9.10271 18.6032 8.34278L17.9524 9.10204L17.3016 9.86129C17.7449 10.2413 18 10.796 18 11.3798H19ZM5 11.3798H6C6 10.796 6.25513 10.2413 6.69842 9.86129L6.04763 9.10204L5.39683 8.34278C4.51025 9.10271 4 10.2121 4 11.3798H5ZM19 16H18C18 17.1046 17.1046 18 16 18V19V20C18.2091 20 20 18.2091 20 16H19ZM10.0476 5.67346L10.6984 6.43272C11.4474 5.79074 12.5526 5.79074 13.3016 6.43272L13.9524 5.67346L14.6032 4.91421C13.1052 3.63024 10.8948 3.63024 9.39683 4.91421L10.0476 5.67346ZM5 16H4C4 18.2091 5.79086 20 8 20V19V18C6.89543 18 6 17.1046 6 16H5Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14 19V15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15V19",
		stroke: "currentColor",
		strokeWidth: 2
	})]
});
export default SvgToHome;
